// **********************************************************************
// ******** Serviços oferecidos pelo Prestador que trabalha sozinho *********
// ******** app/PrestadorProfile/prestadorservicos.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 06/11/24 | 21h55
// ******** data: 11/11/24 | 16h15 | correção de bugs/conclusão da página
// ******** Serviços oferecidos pelo Prestador que trabalha sozinho *********
// **********************************************************************




import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import apiaxios from '../../../../Services/apiaxios';
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import Footer from '../../components/Footer/footer';
import './prestadorservicos.css';

function PrestadorServicos() {
    const { state } = useLocation();
    // console.log ('state prestador servicos ', state);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id } = useParams();
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPrestador || null);
    const [nomeEmpresa, setNomeEmpresa] = useState(state?.nomePrestador || null);
    const [enderecoEmpresa, setEnderecoEmpresa] = useState(state?.enderecoPrestador || null);
    const [celularEmpresa, setCelularEmpresa] = useState(state?.celularPrestador || null);
    const [intervaloAgendamento, setIntervaloAgendamento] = useState(state?.intervaloAtendimento || 60);
    const [servicos, setServicos] = useState([]);
    // const [intervaloAgendamento, setIntervaloAgendamento] = useState(30); // Default value    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const servicosRef = useRef(null);  // Ref para a seção de serviços

    // verifica se é mobile, tablet, NB, PC, etc
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        fetchServicos(id);
    }, [id]);

    const fetchServicos = async (id_empresa) => {
        setLoading(true);
        // console.log("empresa ID: ", id, id_empresa);
        try {
            // const response = await apiaxios.get(`/servico/listar`, { // rota desprotegida
            const response = await apiaxios.get(`/empresaLink/servicoListarWeb`, { // rota desprotegida
                    params: { id_empresa }
            });

            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setServicos(response.data);
                    fetchServicosFoto(response.data);
                    // Aguardar um ciclo de renderização antes de rolar
                    // console.log('fetchservicos');
                    setTimeout(() => {
                        if (servicosRef.current) {
                            servicosRef.current.scrollIntoView({ behavior: 'smooth' });
                        }
                    }, 100); // Atraso pequeno para garantir que a renderização ocorreu
                } else {
                    setError('Nenhum serviço disponível ou encontrado no momento. Tente mais tarde!');
                    Swal.fire('Erro', error, 'error');
                }
            } else {
                const errorMessage = response.data.retorno || 'Erro desconhecido';
                setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.retorno || 'Erro desconhecido';
                setError(errorMessage);
                // alert('catch');
                Swal.fire('Erro', errorMessage, 'error');
            } else {
                setError('Erro ao carregar serviço(s) do Estabelecimento.');
                Swal.fire('Erro', 'Erro ao carregar serviço(s) do Estabelecimento.', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    // carrega na sequência a foto de todos os serviços
    const fetchServicosFoto = async (servicosFotos) => {
        // console.log('fetchServicosFoto ', servicosFotos);
        const promises = servicosFotos.map(async (servico, index) => {
            try {
                const fotoResponse = await apiaxios.get(`/servico/FotoServicoWeb?id_usuario=${id}&id_servico=${servico.ID_SERVICO}`);
                // console.log('foto colaborador ', fotoResponse.data.foto);
                // console.log('data prestador fotos: ', fotoResponse.data);
                if (fotoResponse.data.retorno === "OK" && fotoResponse.data.foto) {
                    servico.SER_FOTO = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
                }
            } catch (error) {
                // handleApiError(error); // função inexistente nesta página 28/10/24w
                console.error(error);
            } finally {
                // Update the state with the new data including the photo
                setServicos(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = servico;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };

    const handleServicoClick = (servicoId, servicoNome, servicoValor) => {
        navigate(`/agendar/${linkpersonalizado}/${id}/servico/${servicoId}/agendamento` , { 
            state: { 
                nomeEmpresa, 
                enderecoEmpresa, 
                fotoPerfil, 
                servicoNome, 
                servicoValor, 
                celularEmpresa,
                intervaloAgendamento // vem do servidor o intervalo (de 30 a 120 min) 12/11/24w
            } 
        });
    };

    const handleBackClick = () => {
        navigate(-1); // Navegar para a página anterior
    };

    const formatCurrency = (value) => {
        // if (value === undefined || value === null) {
        //     return 'R$ 0,00';
        // }
        if (value === undefined || value === null || value === 0) {
            return 'Valor a combinar';
        } else {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    };

    // if (loading) return <div>Carregando...</div>;
    // if (error) return <div>{error}</div>;



    return (
        <div>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col py-3 me-3 text-center">
                        <button className="btn btn-secondary back-button position-fixed top-0 start-0 m-3" onClick={handleBackClick}>
                            <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Voltar'}
                        </button>
                        <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                        <br/>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}

                        {fotoPerfil ? (
                            <div className='text-center'>
                                <img src={fotoPerfil} alt={nomeEmpresa} className='usuario-foto'/>
                            </div>
                        ) : (
                            <p>{nomeEmpresa}</p>                                        
                        )}

                        <br />
                        {servicos.length > 0 ? (
                            <div ref={servicosRef} className="box-colaboradores">
                                <h5>Escolha o serviço e clique no botão "Agendar"</h5>
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th className="text-right"></th>
                                        </tr>
                                    </thead>  
                                    <tbody>
                                        {servicos.map((servicos) => (
                                        <tr key={servicos.ID_SERVICO}>
                                            {/* {console.log('servicos')} */}
                                            <td data-label="">
                                                {servicos.SER_FOTO ? (
                                                        // <img src={servicos.SER_FOTO} alt='' height="84" width="56" className='usuario-foto'/>
                                                        <img src={servicos.SER_FOTO} alt='' className='prestador-servico-foto'/>
                                                    ) : (
                                                        ''
                                                )}
                                            </td>
                                            <td className="text-center fs-5" data-label="">{servicos.DESCRICAO}</td>
                                            {/* <td data-label="">
                                                {servicos.VR_TOTAL === 0 ? (
                                                    'VALOR A COMBINAR'
                                                ) : (
                                                    formatCurrency(servicos.VR_TOTAL)
                                                )}
                                            </td> */}
                                            <td data-label="">
                                                {formatCurrency(servicos.VR_TOTAL)}
                                            </td>
                                            <td className="text-right">
                                                <button
                                                    onClick={() => handleServicoClick(servicos.ID_SERVICO, servicos.DESCRICAO, formatCurrency(servicos.VR_TOTAL))}
                                                    className="btn btn-success ml-10"
                                                >
                                                    <i className="bi bi-clock-history"></i> Agendar
                                                </button>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <h5 className='danger'>{error}</h5>
                        )} 
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrestadorServicos;